import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index";
import { Scrudo, SEtiqueta, SInput, SInputD } from "./general.js";
import Boton from "./Boton"

export default function CRUDproyecto() {
  let { firebase } = useContext(AppContext);
  let p = firebase.proyectoActivo.proyecto;
  const [fotoPm, setFotoPm] = useState(null);
  const [refresh, setRefresh] = useState(false)
  const [change, setChange] = useState(false)

  useEffect(() => {
    document.getElementById("htmlTituloPag").innerHTML = p.id + ": " + p.nombre;
    document.getElementById("htmlTituloPagS").innerHTML = "Datos básicos";
  }, [p.nombre, p.id]);

  useEffect(() => {
    let u = firebase.usuario(p.pm);
    if (u) {
      setFotoPm(u.url);
    }
  }, [firebase, p.pm, p.id, p.nombre]);

  function actualizarProyecto() {
    firebase.actualizarProyectoActivo()
    setRefresh(!refresh)
    setChange(false)
  }

  return (
    <div style={Sdatos}>
      <div style={Scrudo}>
        <div style={SDataEntry}>
          <div style={SEtiqueta}>
            Proyecto: {p.id}</div>
          <input
            id="nombre"
            type="text"
            size="50"
            autoComplete="off"
            defaultValue={p.nombre}
            onChange={(e) => {
              e.persist(); setChange(true);
              p.nombre = e.target.value;
            }}
            style={SInput}
          ></input>
          <div style={SEtiqueta}>PM:</div>
          <select
            id="pm"
            value={p.pm}
            onChange={(e) => {
              e.persist(); setChange(true);
              p.pm = e.target.value;
              setFotoPm(firebase.usuario(p.pm).url);
            }}
            style={SInput}
          >
            <option value=""></option>
            {firebase.dataUsuarios.map((u, i) => (
              <option key={i} value={u.id}>
                {u.nombre}
              </option>
            ))}
          </select>
          <div style={SEtiqueta}>Prioridad:</div>
          <select
            id="prioridad"
            defaultValue={p.prioridad}
            onChange={(e) => {
              e.persist(); setChange(true);
              p.prioridad = e.target.value;
            }}
            style={SInput}
          >
            <option value=""></option>
            <option value="Alta">Alta</option>
            <option value="Media">Media</option>
            <option value="Baja">Baja</option>
          </select>
          <div style={SEtiqueta}>Tipo:</div>
          <select
            id="tipo"
            defaultValue={p.tipo}
            onChange={(e) => {
              e.persist(); setChange(true);
              p.tipo = e.target.value;
            }}
            style={SInput}
          >
            <option value=""></option>
            <option value="Cascada">Cascada</option>
            <option value="Agil">Agil</option>
          </select>
        </div>
        <div style={{ ...SEtiqueta, marginBottom: "5px" }}>Descripción: </div>
        <textarea
          id="descripcion"
          rows="2"
          maxLength="200"
          defaultValue={p.descripcion}
          onChange={(e) => {
            e.persist(); setChange(true);
            p.descripcion = e.target.value;
          }}
          style={SInputD}
        ></textarea>
        <div><Boton accion={actualizarProyecto} change={change} /></div>
      </div>
      <img src={fotoPm} alt="?" height="100px" width="100px" style={Sfoto} />
    </div>
  );
}

const Sdatos = {
  display: "flex",
  flexDirection: "row",
  margin: "30px"
}

const SDataEntry = {
  display: "grid",
  gridTemplateColumns: "50% 50%",
  rowGap: "5px",
  columnGap: "5px",
};

const Sfoto = {
  marginTop: "15px",
  clipPath: "circle(50%)",
  marginLeft: "30px",
};
